import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import ModalCEConfigShippingCompany from './MCECShippingCompany'
import { ShippingCompanyModelType } from '@teinor/erp/types/company/config/shipping/shippingCompany'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import ConfigShippingServices from './CShippingServices'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRow, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import locations from '../../../../../../utils/globals/locations'
import ModalDeleteShippingCompany from './MDeleteShippingCompany'

interface ConfigShippingCompaniesProps extends ComponentWithPermissions { }

const ConfigShippingCompanies: React.FC<ConfigShippingCompaniesProps> = ({ userPermissions }) => {
    const { ShippingCompanyId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={ConfigShippingCompaniesInner} SecondChild={ConfigShippingServices} displaySecond={ShippingCompanyId !== 'main'} />)
}


const ConfigShippingCompaniesInner: React.FC<ConfigShippingCompaniesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('shippingCompanies', 'Transportistas'),
        newText: t('newShippingCompany', 'Nuevo Transportista'),
    }
    return (
        <BaseScreenTable TableComponent={TableConfigShippingCompany} CreateModalComponent={ModalCEConfigShippingCompany} EditModalComponent={ModalCEConfigShippingCompany} pageData={pageData} userPermissions={userPermissions} DeleteModalComponent={ModalDeleteShippingCompany} />
    )
}

interface ShippingCompanyModelTypeExtended extends ShippingCompanyModelType {
    'Supplier.name': string
    'ShippingCompany.name': string
}

interface TableConfigShippingCompanyProps extends TableComponentProps { }

const TableConfigShippingCompany: React.FC<TableConfigShippingCompanyProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { ShippingCompanyId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(ShippingCompanyId || '')
    const columns: ColumnTableSchema<ShippingCompanyModelTypeExtended> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchKey: 'ShippingCompany.name',
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'SupplierId',
            dataKey: 'Supplier.name',
            label: t('creditor', 'Acreedor'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('creditor', 'Acreedor') }
            }
        },
        {
            id: 'factor',
            dataKey: 'factor',
            label: t('factorVolKgMeters', 'Factor Volumen kg/m3'),
            minWidth: 170
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[locations.shippingCompanies, ['$id']]} name='shippingCompanies' extraWhereParams={{ active: true }} columns={columns} getDataFrom='/api/app/config/shipping/shippingCompany/getAllShippingCompanies' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} />
    )
}


export default ConfigShippingCompanies